// extracted by mini-css-extract-plugin
export default {"container":"SortCell_container__J7l5A","idleSortIcon":"SortCell_idleSortIcon__5zHD5"};